interface Props {
  onOpenPolicy: (type: 'terms' | 'privacy') => void;
}

export default function FooterSection({ onOpenPolicy }: Props) {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as URLSearchParams);
    try {
      await fetch('https://readdy.ai/api/form/d73c5oklqq77n94m7g5g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString()
      });
      (form.querySelector('input[name="email"]') as HTMLInputElement).value = '';
    } catch {
      // silent
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#0A1B4B] via-[#0F2D8A] to-[#1850CC]">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img src="https://public.readdy.ai/ai/img_res/329b747f-c748-48a9-a4d0-2bc2d9affcc1.png" alt="logo" className="w-9 h-9 object-contain" />
              <span className="text-white font-bold text-lg">习惯星球</span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed mb-6 max-w-sm">科学的积分奖惩机制，帮助家庭培养孩子六大核心习惯，让成长变得有迹可循、有据可查。</p>
            <form onSubmit={handleSubmit} className="flex gap-2" data-readdy-form>
              <input type="email" name="email" placeholder="输入邮箱订阅最新动态" className="flex-1 bg-white/10 backdrop-blur-sm text-white placeholder-white/30 border border-white/20 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-white/50 transition-colors" />
              <button type="submit" className="whitespace-nowrap bg-amber-400 hover:bg-amber-300 text-white px-4 py-2.5 rounded-xl transition-colors cursor-pointer">
                <i className="ri-send-plane-fill"></i>
              </button>
            </form>
          </div>
          <div>
            <div className="text-white/40 text-xs uppercase tracking-wider mb-4 font-medium">快速导航</div>
            <ul className="space-y-2.5">
              {['产品功能', '会员权益', '激励市场', '帮助中心', '关于我们'].map(l => (
                <li key={l}><a href="#" className="text-white/70 text-sm hover:text-white transition-colors">{l}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <div className="text-white/40 text-xs uppercase tracking-wider mb-4 font-medium">关注我们</div>
            <ul className="space-y-2.5">
              {[
                { icon: 'ri-wechat-fill', label: '微信公众号' },
                { icon: 'ri-tiktok-fill', label: '抖音' },
                { icon: 'ri-weibo-fill', label: '微博' }
              ].map(s => (
                <li key={s.label}>
                  <a href="#" className="flex items-center gap-2 text-white/70 text-sm hover:text-white transition-colors">
                    <i className={`${s.icon}`}></i>
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-sm">© 2026 习惯星球. All rights reserved.</p>
          <div className="flex gap-4">
            <button onClick={() => onOpenPolicy('terms')} className="text-white/40 text-xs hover:text-white/70 transition-colors cursor-pointer bg-transparent border-none">用户协议</button>
            <button onClick={() => onOpenPolicy('privacy')} className="text-white/40 text-xs hover:text-white/70 transition-colors cursor-pointer bg-transparent border-none">隐私政策</button>
            <a href="#" className="text-white/40 text-xs hover:text-white/70 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
      <div className="text-center py-6 px-4 overflow-hidden border-t border-white/10">
        <h2 className="text-4xl md:text-6xl lg:text-8xl font-black tracking-tight bg-gradient-to-r from-blue-200/30 to-cyan-200/20 bg-clip-text text-transparent whitespace-nowrap">习惯星球</h2>
      </div>
    </footer>
  );
}
